import http from './http.js';
import { isEmpty, isNil, overPath } from '../utils/fp';
import { configParser, searchParser } from '../lib/search';
import { datasources } from '../lib/settings';

let globalConfig = {};

const setConfig = config => (globalConfig = { ...globalConfig, ...config });

const endpoint = (path, config = globalConfig) => {
  if (isNil(config.endpoint)) return;
  return `${config.endpoint}${path}`;
};

const _get =
  (path, parser) =>
  async ({ requestArgs, parserArgs }) => {
    const url = endpoint(path);
    if (isNil(url)) throw new Error('Search endpoint missing');

    const tenant = window?.CONFIG?.member?.id;
    if (isNil(tenant)) throw new Error('Tenant missing');
    if (isEmpty(datasources)) throw new Error('Datasource(s) missing in the scope');

    const prepareRequestArgs = args =>
      overPath(
        ['facets', 'datasourceId'],
        current => (isNil(current) || isEmpty(current) ? Object.keys(datasources) : current),
        args,
      );

    const data = await http
      .post(url, { json: prepareRequestArgs(requestArgs), searchParams: { tenant } })
      .json();
    return parser(parserArgs)(data);
  };

const getConfig = _get('/search', configParser);
const getSearch = _get('/search', searchParser);

const getIsIndexedDataflows = ({ requestsArgs = [] }) =>
  Promise.all(requestsArgs.map(requestArgs => getSearch({ requestArgs })));

const methods = {
  setConfig,
  getConfig,
  getSearch,
  getIsIndexedDataflows,
};

const error = method => () => {
  throw new Error(`Unkown method: ${method}`);
};

const main = ({ method, ...rest }) => (methods[method] || error(method))(rest);
Object.entries(methods).forEach(([name, fn]) => (main[name] = fn));

export default main;
